import React from 'react';
import './FourFourFourAI.css';

function ThirukuralAI() {
  return (
    <div className="thirukural-ai-container">
      <div className="thirukural-ai-content">
        <h1 className="app-name">Aileesa</h1>
        <p className="tagline">Aileesa is your solution for local ecommerce.</p>
        
        <div className="intro-section">
          <p className="intro-text">
            Aileesa is an intelligent app that serves as a local ecommerce platform. 
            The app is designed to provide an engaging and immersive experience for users who want to explore local products and services in a modern and accessible way.
            With Aileesa, you can easily navigate through a wide range of local offerings, connect with nearby businesses, and discover unique products that cater to your needs.
            Whether you're a shopper looking for local gems or a business owner aiming to reach a wider audience, Aileesa offers a unique and enriching way to connect with your community and support local commerce.
          </p>
        </div>

        <div className="features-brief">
          <div className="feature-item">
            <span className="emoji">🧠</span>
            <h3>Intelligent Support</h3>
            <p>AI that understands and responds to your local ecommerce needs</p>
          </div>
          <div className="feature-item">
            <span className="emoji">🎧</span>
            <h3>Immersive Experience</h3>
            <p>Engage with local businesses and services through our AI backed platform</p>
          </div>
        </div>
        </div>
      </div>
  );
}

export default ThirukuralAI;
